import {
  Component,
  HostBinding,
  ViewEncapsulation,
  inject,
} from "@angular/core";
import { Observable } from "rxjs";
import { CompStep } from "../../models";
import { CompProductFacade } from "../../services/comp-product-facade";
import {
  StepperComponent,
  StepperStepTemplateDirective,
} from "@progress/kendo-angular-layout";
import { AsyncPipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-comp-product-stepper",
  templateUrl: "./comp-product-stepper.component.html",
  styleUrls: ["./comp-product-stepper.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [
    StepperComponent,
    StepperStepTemplateDirective,
    AsyncPipe,
    TranslateModule,
  ],
})
export class CompProductStepperComponent {
  facade = inject(CompProductFacade);

  @HostBinding("class") class = "comp-product-stepper";
  public _currentStep: number = 0;
  public step$: Observable<CompStep[]>;
  private skippedSteps = new Set<number>();
  constructor() {
    const facade = this.facade;

    this.step$ = facade.compSteps$;
    facade.currentStepNumber$.subscribe((r) => (this._currentStep = r));

    this.step$.subscribe((steps) => {
      if (
        steps[this._currentStep]?.compProducts.length === 0 &&
        !this.skippedSteps.has(this._currentStep)
      ) {
        steps[this._currentStep].isSkippable = true;
        this.skippedSteps.add(this._currentStep);
        this.facade.goToNextStep();
      }
    });
  }

  setCurrentStep(index: number) {
    this.skippedSteps.forEach((step) => {
      if (step > index) {
        this.skippedSteps.delete(step);
      }
    });

    this.facade.revertStepTo(index);
  }
}
